module.exports = __webpack_public_path__ + "src/assets/img/jeep-img.aca524f1.png";